import * as React from "react";
import Icon from "../icons/icon";
import classNames from "classnames";
import Anchor from "../anchor/anchor";

export interface ISearchProps {
    title?: string;
    disableBackgroundColor?: boolean;
    searchResultsPageUrl?: string;
    searchButtonLabel?: string;
    searchInputPlaceholder?: string;
    searchInputPrefill?: string;
    richText?: string;
    enableAutoFocus?: boolean;
    anchorId?: string;
}

export interface ISearchState {
    searchString: string;
}

class Search extends React.Component<ISearchProps, ISearchState> {
    private inputField: HTMLInputElement | null;
    public state = {
        searchString: this.props.searchInputPrefill || ""
    };

    public componentDidMount = () => {
        // To make sure the cursor is placed after the input value
        if (this.inputField) {
            this.inputField.value = this.state.searchString;
        }
    };

    public onChange = (event: React.FormEvent<HTMLInputElement>) => {
        const { value } = event.target as HTMLInputElement;

        this.setState({
            searchString: value
        });
    };

    public render() {
        const {
            title,
            disableBackgroundColor,
            searchResultsPageUrl,
            searchButtonLabel,
            searchInputPlaceholder,
            richText,
            anchorId
        } = this.props;

        const baseClass = "search-module";
        const componentClasses = classNames(baseClass, {
            "anchor-wrapper": !!anchorId,
            [`${baseClass}--theme-background`]: !disableBackgroundColor
        });

        return (
            <section className={componentClasses}>
                {anchorId && <Anchor id={anchorId} />}
                <div className={`${baseClass}__inner`}>
                    {title ? <h2 className={`${baseClass}__title h2-style`}>{title}</h2> : null}
                    {richText && (
                        <div
                            className={`${baseClass}__rich-text content-rich-text`}
                            dangerouslySetInnerHTML={{ __html: richText }}
                        />
                    )}
                    {searchResultsPageUrl && searchInputPlaceholder && searchButtonLabel ? (
                        <form
                            className={`${baseClass}__form`}
                            role="search"
                            action={searchResultsPageUrl}
                            method="get"
                        >
                            <div className={`${baseClass}__input-wrapper`}>
                                <input
                                    ref={node => (this.inputField = node)}
                                    name="search"
                                    className={`${baseClass}__input input`}
                                    placeholder={searchInputPlaceholder}
                                    onChange={this.onChange}
                                    type="search"
                                    autoFocus={this.props.enableAutoFocus}
                                />
                                <button
                                    className={`${baseClass}__button`}
                                    type="submit"
                                    title={searchButtonLabel}
                                >
                                    <Icon iconId="32_search" />
                                </button>
                            </div>
                        </form>
                    ) : null}
                </div>
            </section>
        );
    }
}

export default Search;
